import React, { useState } from "react";

import { SaveButton, useNotify, useRedirect } from "react-admin";

import { logError } from "../../../utils/appUtils";
import { doUpdateReloadYardAccount } from "../../../managerApp/resources/customers/customerUtils";

export const ValidateSaveButton = ({ record, backPath, ...props }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [isSaving, setIsSaving] = useState(false);

  const transform = (data) => {
    data = { ...data };
    debugger;

    data.email = data.email.toLowerCase();

    delete data.accountId;
    delete data.reloadYardAccounts;

    return data;
  };

  const onSuccess = async ({ data }) => {
    debugger;
    try {
      if (data.lastName !== record.lastName) {
        const reloadYardAccount = {
          ...data.reloadYardAccounts.items[0],
          lastName: data.lastName,
        };
        await doUpdateReloadYardAccount(reloadYardAccount);
      }

      notify(`User updated successfully.`);
      redirect(backPath);
    } catch (error) {
      logError(
        "managerApp:customers:ValidateSaveButton:onSuccess",
        error,
        notify
      );
    } finally {
      setIsSaving(false);
    }
  };

  const onFailure = (error) => {
    setIsSaving(false);
    logError(
      "managerApp:customers:ValidateSaveButton:onFailure",
      error,
      notify
    );
  };

  return (
    <SaveButton
      {...props}
      submitOnEnter={false}
      undoable={false}
      disabled={props.pristine}
      saving={isSaving}
      transform={transform}
      onSuccess={onSuccess}
      onFailure={onFailure}
    />
  );
};
